import { DateTime } from 'luxon';

type DateRange = {
  fromDate: string;
  toDate: string;
};

export const splitDateRanges = (dateRange: DateRange): DateRange[] => {
  const { fromDate, toDate } = dateRange;
  if (fromDate && toDate) {
    const start = DateTime.fromISO(fromDate);
    const end = DateTime.fromISO(toDate);
    return chunk(start, end, 3);
  }

  return [dateRange];
};

const chunk = (start: DateTime, end: DateTime, size: number) => {
  const duration = end.diff(start, ['days']);
  const duationExclStrtEnd = duration.days - 2;
  const val = Math.round(duationExclStrtEnd / size);
  if (duration.days < 2) {
    return [{ fromDate: start.toISODate(), toDate: end.toISODate() }];
  }
  const days = Array.from({ length: size }).map((_, i) => {
    if (i === size - 1) {
      return duationExclStrtEnd - val * (size - 1);
    }
    return val;
  });

  let current = DateTime.fromISO(start.toISO());

  return days.reduce((a, d: number) => {
    const d1 = DateTime.fromISO(current.toISO());
    const d2 = d1.plus({ days: d });
    current = d2.plus({ days: 1 });
    if (d1 <= end) {
      a.push({
        fromDate: d1.toISODate(),
        toDate: (d2 > end ? end : d2).toISODate()
      });
    }
    return a;
  }, [] as DateRange[]);
};
